import React from 'react';

import DevelopmentProcess from '../../component/developmentProcess/DevelopmentProcess';

const Accounts = () => {
  return <DevelopmentProcess name="Accounts" />;
};

export default Accounts;
